import { connect } from 'react-redux'
import { compose } from 'recompose'
import withType from 'components/common/hoc/withType'
import BOTRecentlyAddedProductService from './BOTRecentlyAddedProductService'

export default compose(
  withType({ type: 'BOTRecentlyAddedProductService' }),
  connect(({ addToQuote }) => addToQuote)
)(BOTRecentlyAddedProductService)
